import { SpecialOfferProps } from '../types';
import { StyledMe2onSpecialOffer } from './style';
import { Box } from '@mui/system';
import { Me2onSaleBadge } from '../../Badge/Sale/Me2onSaleBadge';
import { EBundlesInternalViewModel } from '../../Helper/enums';
import BundlePrice from '../../Bundles/BundlePrice';

const SpecialOffer = ({
    price,
    productsList,
    availability,
    backgroundColor,
    backgroundImage,
    selectOffer,
    salePercentage = 0,
    salePercentageDisplayType,
    buttonColor,
    isFree,
    collectText,
    availabilityText
}: SpecialOfferProps) => {
    return (
        <StyledMe2onSpecialOffer
            onClick={selectOffer}
            backgroundColor={backgroundColor}
            backgroundImage={backgroundImage}
            buttonColor={buttonColor}
        >
            <Box className="container">
                {salePercentage > 0 && (
                    <Me2onSaleBadge
                        salePercentage={salePercentage}
                        salePercentageDisplayType={salePercentageDisplayType}
                    />
                )}
                <Box className="products">
                    {productsList.slice(0, 3).map((product) => (
                        <Box className="product">
                            <Box className="product-container">
                                <img
                                    src={product.images.product}
                                    alt="product"
                                    className="product-container--image"
                                />
                            </Box>
                            <Box className="product-amount">
                                {product.quantityDisplay &&
                                    `${product.quantityDisplay} chips`}
                            </Box>
                            {salePercentage > 0 && (
                                <p className="stroked">
                                    {product.strokedSaleQuantity}
                                </p>
                            )}
                        </Box>
                    ))}
                </Box>
                <Box className="price-container">
                    {availabilityText && availability && (
                        <Box className="availability">
                            {availabilityText} {availability.remaining} /{' '}
                            {availability.total}
                        </Box>
                    )}
                    <BundlePrice
                        price={price}
                        type={EBundlesInternalViewModel.ME2ON}
                        whiteStripe={true}
                        isFree={isFree}
                        buttonText={collectText}
                    />
                </Box>
            </Box>
        </StyledMe2onSpecialOffer>
    );
};

export default SpecialOffer;
